import { FloraTypography } from '@grupoboticario/flora-react'

interface CharacterCounterProps {
  current: number
  max: number
}

const CharacterCounter = ({ current, max }: CharacterCounterProps) => {
  const remaining = max - current

  return (
    <FloraTypography
      css={{
        textAlign: 'right',
        marginTop: '$1',
        color: remaining < 0 ? '$error' : '$medium-light-1'
      }}
      fontSize="bodySmallStandard"
    >
      {remaining} {remaining === 1 ? 'caractere restante' : 'caracteres restantes'}
    </FloraTypography>
  )
}

export default CharacterCounter
